import React from 'react';
import { convertCamelCaseToTitle } from '../../utils';
import { Attribute } from '../../types/PDP';
import './styles.scss';

// ? [REVISIT] why is this it's own file? how is this different from the normal apparelAttribs`, just the classname?
const TestedAndApproved = ({ attribute: { label, value } }: { attribute: Attribute }) => (
  <div className="testedAndApproved">
    <h4 className="testedAndApproved-title">{convertCamelCaseToTitle(label)}</h4>
    <ul>
      {value?.split(/\r?\n/).map((text, idx) => (
        <li className="small-p" key={idx}>
          {text}
        </li>
      ))}
    </ul>
  </div>
);

export default TestedAndApproved;
